import { FC, PropsWithChildren } from 'react';
import { EditMode } from './types';
import {
  createStore,
  InputCommentsUpdateResponseType,
  InputUpdateResponseType,
  ValidationMessagesMap,
} from '@atlas-frontend/sdk';

export interface InputDataError {
  errors: ValidationMessagesMap;
  type?: string;
}
export interface InputDataDetailsContextValue {
  segment: string | number;
  total: number;
  totalElements: number;
  commentsTotal: number;
  isLoading?: boolean;
  mode: EditMode;
  mutationErrors?: InputDataError;
  savedVersion?: InputUpdateResponseType & InputCommentsUpdateResponseType;
  showOutputs?: boolean;
}

export const InputDataDetailsStore =
  createStore<InputDataDetailsContextValue>();
export const useInputDataDetailsStoreValue = InputDataDetailsStore.useValue;
export const useSetInputDataDetailsStoreValue =
  InputDataDetailsStore.useSetValue;

export const InputDataDetailsContextProvider: FC<PropsWithChildren> = (
  props,
) => {
  const { children } = props;

  return (
    <InputDataDetailsStore.Provider
      initialData={{
        total: 0,
        totalElements: 0,
        commentsTotal: 0,
        mode: 'view',
        segment: 'data',
      }}
    >
      {children}
    </InputDataDetailsStore.Provider>
  );
};
